import React, { Fragment } from 'react'
import { useMemo } from 'sb-hooks'
import { useConnect } from 'sb-redux-hook'
import { constants, array } from 'common/helpers'

import { Box } from 'components/_new/layout'
import Text from 'components/_new/typography/Text/Text'

import Link from '../Link/Link'


const OtherLinks: React.FunctionComponent = () => {
  const { pathname, gender, tags } = useConnect({
    pathname: 'view.seoPage.pathname',
    gender: 'view.seoPage.gender',
    tags: 'view.seoPage.tags',
  })

  const activeTags  = useMemo(() => tags && tags[gender] ? (
    tags[gender].filter(({ productsCount }) => productsCount > 0)
  ) : [], [ tags, gender ])

  const tagsGroups = useMemo(() => {
    const groups = array.groupBy(activeTags, 'type')

    return Object.keys(groups).map((type, index) => ({
      type,
      tags: groups[type].map(({ name }) => {
        let link = '/'

        link += name.replace(/\s/g, '-').toLowerCase()

        if (constants.exceptionTags.includes(name)) {
          link = `/tag${link}`
        }

        if ([ 'perfumes', 'colognes', 'fragrance' ].includes(pathname)) {
          link += `-${pathname}`
        }
        else {
          link += gender === 'female' ? '-perfumes' : '-colognes'
        }

        return {
          name,
          link,
        }
      }),
    }))
  }, [ activeTags ])

  return (
    <Fragment>
      {
        tagsGroups.map(({ type, tags }, index) => (
          <Box key={type} mt={index ? 20 : null}>
            <Text message={type} size="14-16" color="gray-50" uppercase />
            <Box mt={16}>
              {
                tags.map(({ name, link }) => (
                  <Link key={name} to={link}>
                    <Text
                      message={name}
                      size="12-24"
                      color="black"
                      uppercase
                    />
                  </Link>
                ))
              }
            </Box>
          </Box>
        ))
      }
    </Fragment>
  )
}


export default React.memo(OtherLinks)
